import React, { useState } from 'react';
import { Container, Nav, Navbar, Form } from 'react-bootstrap';
import styled from 'styled-components';
import logo from '../assets/mainlogo.png';
import { useTranslation } from 'react-i18next';

const Styles = styled.div` 
// CHECKING ONLY: 
.langCheck {
    position: absolute;
    background-color:gray;
    font-size:8px;
    color:white;
    z-index:999;
    bottom:0;
    display:none;
}
 
 
`;


const NavigationBar = () => {
    const { t, i18n } = useTranslation();
    const [nameLang, setLang] = useState('en'); // constructor + prop

    const handlenameLangChange = (e) => {
        setLang(e.target.value)  // Set Value
        // console.log("handleName Change : "+e.target.value);
        i18n.changeLanguage(e.target.value);
    }

    return (
        <Styles>
            {/* <div className="langCheck">
                {t('navigation-link.1')} <br />
                {t('navigation-link.2')}<br />
                {t('navigation-link.3')}<br />
                {t('navigation-link.4')}<br />
            </div> */}

            {/* <Navbar bg="white" expand="lg" className="fixed-top navShadow"> */}
            <Navbar bg="white" expand="lg" className="navShadow navpaddingBtm fixed-top animate__animated animate__slideInDown animate__faster">
                <Container>
                    <Navbar.Brand href="/">
                        <img src={logo} alt="TTSH" height="50" className="d-inline-block align-top"/>
                    </Navbar.Brand>
                    {/* Appointment @ TTSH  */}
                    
                    {/* <span className="brand-text mobile-brand-text">
                        Appointment @ TTSH 
                         {t('text.2')} TEXTUPDATE
                    </span>  */}

                    <Navbar.Toggle aria-controls="basic-navar-nbav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto nav-link-color">
                            <Nav.Link href="#">
                                {/* CFS Scheme */}
                                {t('navigation-link.1')}
                            </Nav.Link>
                            <Nav.Link href="/#">
                                {/* Tools */}
                                {t('navigation-link.2')}
                            </Nav.Link>
                        </Nav>
                        <Form>
                            <Form.Control id="select-language" as="select" size="sm" onChange={handlenameLangChange} value={nameLang}>
                                <option value="en">English</option>
                                <option value="cn">Chinese</option>
                                <option value="ml">Malay</option>
                                <option value="tm">Tamil</option>
                            </Form.Control>
                        </Form>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Styles >
    );
};


export default NavigationBar;